import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Skip } from 'src/components/Header/components'
import { CustomButton, DynamicInput, Icon } from 'src/components/ui'
import { useGetTypeOfBottleFromUrl } from 'src/hooks'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

import InfoPopup from '../InfoPopup/InfoPopup'

interface Props {
  styles: any
}

const Lottery: React.FC<Props> = ({ styles }) => {
  const [isActivePopup, setIsActivePopup] = React.useState(false)

  const { t } = useTranslation()
  const addBottleAmount = useCreateBottle((state) => state.addBottleAmount)
  const bottleAmount = useCreateBottle((state) => state.bottleAmount)
  const [inputValue, setInputValue] = React.useState<string>(bottleAmount)
  const navigate = useNavigate()

  const typeOfBottle = useGetTypeOfBottleFromUrl()

  const handleChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setInputValue(value)

    e.target.style.width = `${Math.max(value.length - 0.3)}ch`
  }

  const handleContinued = () => {
    addBottleAmount(inputValue)
    navigate(`/create-bottle/step-4?type=${typeOfBottle}`)
  }

  return (
    <>
      <div className={styles.wrapper_input}>
        <div className={styles.input_label}>
          {isActivePopup && <InfoPopup />}
          <label htmlFor='input'>{t('create_bottle.input_desired_amount')}</label>

          <button onClick={() => setIsActivePopup((prevState) => !prevState)}>
            <Icon name='info_icon' />
          </button>
        </div>
        <DynamicInput
          inputValue={inputValue}
          onChange={handleChangeInputValue}
          type='number'
          inputMode='numeric'
          placeholder='0'
        />
      </div>

      <div className={styles.tabs}>
        <Skip to={`/create-bottle/step-4?type=${typeOfBottle}`} />
        <CustomButton
          onClick={handleContinued}
          variant={inputValue.length === 0 ? 'not-active' : 'contained'}
          color='white'
          className={styles.button}
        >
          {t('create_bottle.continue')}
        </CustomButton>
      </div>
    </>
  )
}

export default Lottery
